// extracted by mini-css-extract-plugin
export default {"selector":"ImagePageSizeSelector_selector__956gR"};